import { Icon } from '@mentimeter/ragnar-visuals';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';

const checkIcon = <polyline points="20 6 9 17 4 12" />;

export const CorrectAnswer = ({
  backgroundColor,
  correctAnswer,
  showCorrect,
  hasErrorMargin,
  textColor,
  xPosition,
  lowerBoundary,
  upperBoundary,
  limitTransitions,
}: {
  backgroundColor: string;
  correctAnswer: number;
  showCorrect: boolean;
  hasErrorMargin: boolean;
  textColor: string;
  xPosition: number;
  lowerBoundary: number;
  upperBoundary: number;
  limitTransitions: boolean;
}) => {
  return (
    <Box
      position="absolute"
      left={`${xPosition}px`}
      top="50%"
      style={{
        transform: 'translateX(-50%)',
        transition: limitTransitions ? 'all 0s' : 'opacity 1s ease',
        opacity: showCorrect ? '1' : '0',
      }}
      alignItems="center"
      data-testid="correct-answer"
    >
      <Box
        bg={backgroundColor}
        borderRadius={3}
        display="flex"
        flexDirection="row"
        py={1}
        px={4}
        style={{
          transform: 'translateY(-50%)',
        }}
        alignItems="center"
      >
        <Icon size={7} color={textColor}>
          <Feather>{checkIcon}</Feather>
        </Icon>

        <Text ml={3} color={textColor} fontSize="250" fontWeight="semiBold">
          {correctAnswer}
        </Text>
      </Box>
      {hasErrorMargin && (
        <Box
          alignItems="center"
          mt={-4}
          data-testid="correct-answer-range"
          style={{ textAlign: 'center' }}
        >
          <Text fontSize="200">Accepted answers:</Text>
          <Text fontSize="250" fontWeight="semiBold">
            {lowerBoundary} - {upperBoundary}
          </Text>
        </Box>
      )}
    </Box>
  );
};

function Feather({ children }: { children: React.ReactNode }) {
  return (
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {children}
    </g>
  );
}
